(function () {
    'use strict';

    angular.module('thankview.embedRecorder', ['thankview.global', 'thankview.recorder'])
        .controller('EmbedRecorderController', ['$scope', '$rootScope', '$q', 'ajax', 'recorderService', '$window', '$document', '$timeout', 'mediaServerService', function ($scope, $rootScope, $q, ajax, recorderService, $window, $document, $timeout, mediaServerService) {
            // options object to provide to the recorder module
            $scope.recorderOptions = {
                showTipsButton: true,
                showStartOverButton: true,
            };

            $scope.init = function () {
                $scope.initRecorder();

                // bind on recorder state
                recorderService.onStateChange($scope.stateChange);

                $scope.fetchTranslations();

                $scope.setMediaServer();

                // have method for parent to reset the recorder
                $window.addEventListener('message', (event) => {
                    if (!event.data) { return; }

                    if (event.data === 'reset') {
                        $scope.initRecorder();
                        recorderService.reset();
                        $scope.$apply();
                    }
                });
            };

            $scope.fetchTranslations = function () {
                var locale = $window.config.locale;

                var params = {
                    filename: 'video_request',
                };

                ajax.post('/api/translate/' + locale, params).then(function (data) {
                    $scope.trans = data.trans;
                });
            };

            $scope.initRecorder = function () {
                $scope.recording = null;
            };

            $scope.recordTips = function ($event) {
                if ($event) $event.preventDefault();

                $rootScope.$broadcast('play-recording-tips');
            };

            $scope.stateChange = function (state) {
                $scope.state = state;

                if ($scope.state === 'uploadComplete') $scope.saveVideo();
            };

            $scope.initWebcamRecorder = function () {
                recorderService.webcam.open();
            };

            $scope.openUploadVideo = function () {
                recorderService.fileUploader.open();
            };

            $scope.rerecord = function () {
                var deferred = $q.defer();

                deferred.promise.then(function () {
                    $scope.recording = null;

                    recorderService.reset();
                });

                $rootScope.$broadcast('open-message-confirm', $scope.trans['rerecord-warning'], deferred);
            };

            $scope.reUpload = function () {
                recorderService.fileUploader.reUpload();
            };

            $scope.saveVideo = function () {
                $scope.recording = recorderService.getRecording();

                recorderService.review.load($scope.recording);
            };

            $scope.submitVideo = function () {
                if ($scope.loading) return;

                if (!$scope.recording) {
                    $rootScope.$broadcast('open-message', $scope.trans['submit-warning']);
                    return;
                }

                const recording = angular.copy($scope.recording);

                $window.parent.postMessage({ message: 'recording', recording: recording }, '*');
            };

            $scope.setMediaServer = function () {
                if (config.env !== 'production') {
                    return;
                }

                mediaServerService.getMediaServer().then((server) => {
                    config.mediaUrl = server;
                });
            };

            $scope.init();
        }]);
}());
